import {
  ReviewsServiceName,
  SelectedReview
} from "@bluframe/mightychroma-mightytool-frontend-types"

import HeaderPods from "./HeaderPods"

export interface Props {
  areReviewsLoading: boolean
  avForums: SelectedReview
  avNirvana: SelectedReview
  avsForum: SelectedReview
  bluRay: SelectedReview
  bluRayAuthority: SelectedReview
  digitalBits: SelectedReview
  doBlu: SelectedReview
  hidefDigest: SelectedReview
  highDefDiscNews: SelectedReview
  homeTheaterForum: SelectedReview
  isCompact: boolean
  left: React.ReactNode

  onClear: (serviceName: ReviewsServiceName) => () => void
  onSetReview: (
    serviceName: ReviewsServiceName
  ) => (review: SelectedReview["review"]) => void
  theaterByte: SelectedReview
  whySoBlu: SelectedReview
}

export interface ComponentProps extends Props {}

export default HeaderPods
